import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spinner,
} from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import {
  ConnectContactRequest,
  ContactListItem,
} from '@texas/api/endpoints/contactsApi';
import { defaultIconSize, Icons } from '@texas/components/shared/Icons';
import { ArchivedTooltip } from '@texas/components/shared/tooltip/ArchivedTooltip';
import { TFunction } from 'i18next';
import { UserTooltip } from '../shared/tooltip/UserTooltip';

export const contactsColumns = (
  t: TFunction,
  referenceId: number,
  onRemove: (data: ConnectContactRequest) => Promise<void>,
  onEditOpen: (id: number) => void,
  onArchiveOpen: (v: number) => void,
  onRestore: (data: number) => Promise<void>,
  loadingMenuId: number | null,
) => {
  const columnHelper = createColumnHelper<ContactListItem>();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: t('general.name'),
    }),
    columnHelper.accessor('email', {
      cell: (info) => info.getValue(),
      header: t('general.email'),
    }),
    columnHelper.accessor('id', {
      cell: (info) => (
        <Flex justifyContent="end" alignItems="center" gap={2}>
          {info.row.original.archived && (
            <ArchivedTooltip archived={info.row.original.archived} />
          )}
          {info.row.original.user && (
            <UserTooltip
              color="gray.300"
              _light={{ color: 'gray.400' }}
              name={info.row.original.user.name}
              email={info.row.original.user.email}
              iconSize={defaultIconSize}
            />
          )}
          {loadingMenuId === info.getValue() ? (
            <Spinner size="sm" />
          ) : (
            <Menu placement="left" isLazy={true}>
              <MenuButton float="right" aria-label={t('general.more')}>
                <Icons.DotsHorizontal boxSize={6} />
              </MenuButton>
              <Portal>
                <MenuList color="white" zIndex={99}>
                  <MenuItem
                    icon={<Icons.Pencil boxSize={defaultIconSize} />}
                    onClick={() => onEditOpen(info.row.original.id)}
                  >
                    {t('general.edit')}
                  </MenuItem>
                  {info.row.original.user ? (
                    info.row.original.archived ? (
                      <MenuItem
                        icon={<Icons.Archive boxSize={defaultIconSize} />}
                        onClick={() => onRestore(info.row.original.id)}
                      >
                        {t('general.restore')}
                      </MenuItem>
                    ) : (
                      <MenuItem
                        icon={<Icons.Archive boxSize={defaultIconSize} />}
                        onClick={() => onArchiveOpen(info.row.original.id)}
                      >
                        {t('general.archive')}
                      </MenuItem>
                    )
                  ) : (
                    <MenuItem
                      icon={<Icons.TrashOutline boxSize={defaultIconSize} />}
                      onClick={() =>
                        onRemove({
                          id: info.row.original.id,
                          referenceId: referenceId,
                        })
                      }
                    >
                      {t('general.remove')}
                    </MenuItem>
                  )}
                </MenuList>
              </Portal>
            </Menu>
          )}
        </Flex>
      ),
      header: '',
      enableSorting: false,
      maxSize: 100,
    }),
  ];

  return columns;
};
